import { View } from 'pacto';
import { Dialog } from '../../../../dialog/views/Dialog';
import {ConsoleDebug} from "../../../../../_utils/ConsoleDebug";

const ATTRS = {
  TITLE:       'data-info-title',
  INFO_TEXT:   'data-info-icon-text',
  ROLE:        'data-info-role',
  MODAL:       'data-info-modal',
  EXTRA_CLASS: 'data-info-class',
  CLOSE_LABEL: 'data-info-close-label',
};
const CLASS_TOGGLE = 'info-toggle';

export class Textinput extends View {
  constructor(options) {
    super(options);
    this.logInstance = new ConsoleDebug('debug-textinput', 'Textinput');
    this.input = this.getInputElement();
    this.dialog = null;
    this.onToggleMouseenter = this.onToggleMouseenter.bind(this);
    this.onToggleMouseleave = this.onToggleMouseleave.bind(this);
    this.initDialog= this.initDialog.bind(this);
  }

  render() {
    // check whether input field exists and has info text in data Attribute
    if (!this.input || !this.hasDataAttrInfoText(this.input)) {
      return;
    }

    this.logInstance.log('render Dialog for additional Infos');
    // read dialog config from input data attributes
    const config = this.getDialogConfig(this.input);
    // create More-Info-Button
    const toggle = this.createInfoButton(config);
    // create the dialog to display when toggle hovered
    this.initDialog(toggle, config);
  }

  initDialog(toggle, config) {
    config.triggerEl = toggle;
    this.dialog = new Dialog(config);
  }

  // helper methods
  getDialogConfig(input) {
    return {
      content:    input.getAttribute(ATTRS.INFO_TEXT) || '',
      title:      input.getAttribute(ATTRS.TITLE) || 'Tipp:',
      role:       input.getAttribute(ATTRS.ROLE) || 'dialog',
      modal:      input.getAttribute(ATTRS.MODAL) === 'true',
      extraClass: input.getAttribute(ATTRS.EXTRA_CLASS) || '',
      closeLabel: input.getAttribute(ATTRS.CLOSE_LABEL) || 'Schließen',
      id:         input.id ? `info-${input.id}` : `info-${crypto.randomUUID()}` // crypto: Web-Crypto-API im Window für sichere kryptogr. Funktionen
    };
  }

  createInfoButton({ role, title, id }) {
    // add class for extra space
    this.input.classList.add('textinput__input__info-toggle')

    // create and return info-toggle
    const toggle = document.createElement('button');
    toggle.classList.add(CLASS_TOGGLE);
    toggle.type = 'button';
    toggle.setAttribute('aria-haspopup', role);
    toggle.setAttribute('aria-controls', id);
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-label', title);
    toggle.addEventListener('mouseenter', this.onToggleMouseenter);
    toggle.addEventListener('mouseleave', this.onToggleMouseleave);
    this.el.appendChild(toggle);

    this.logInstance.log('Info-Button created')
    return toggle;
  }

  // helper methods
  getInputElement() {
    return this.el.querySelector('input');
  }

  hasDataAttrInfoText(input) {
    return Boolean(input.getAttribute(ATTRS.INFO_TEXT));
  }

  onToggleMouseenter() {
    this.dialog?.hover();
  }

  onToggleMouseleave() {
    this.dialog?.hover();
  }
}
